<template>
  <div id="sponsorsAdmin">
    <app-menu></app-menu>
    <div class="col-lg-10 offset-lg-1 pb-5">
      <h3 class="text-center pb-3 pt-3">Partneři</h3>

      <!-- Texty stránky -->
      <div class="card card-body mb-4">
        <h4 class="text-center pb-3">Texty stránky</h4>
        <div class="row">
          <div class="col-lg-6">
            <h5 class="text-center">Čeština</h5>
            <div class="form-group">
              <label>Úvodní text:</label>
              <html-editor
                v-if="dataLoaded"
                v-model="page.intro.cs"
                :customToolbar="toolbar"
              ></html-editor>
            </div>
            <div class="form-group">
              <label>Závěrečný titulek:</label>
              <input type="text" class="form-control" v-model="page.subtitle.cs" />
            </div>
          </div>
          <div class="col-lg-6">
            <h5 class="text-center">Angličtina</h5>
            <div class="form-group">
              <label>Úvodní text:</label>
              <html-editor
                v-if="dataLoaded"
                v-model="page.intro.en"
                :customToolbar="toolbar"
              ></html-editor>
            </div>
            <div class="form-group">
              <label>Závěrečný titulek:</label>
              <input type="text" class="form-control" v-model="page.subtitle.en" />
            </div>
          </div>
        </div>
        <div class="text-center pt-3">
          <send-button ref="pageBtn" :send="savePage" text="Uložit texty" :response="error" />
        </div>
      </div>

      <!-- Sekce -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h4 class="mb-0">Sekce a loga</h4>
        <button class="btn btn-success" @click="addSection">Přidat sekci</button>
      </div>
      <p class="text-muted">Pořadí sekcí na stránce měňte přetažením.</p>

      <draggable v-model="sections" handle=".drag-handle" @change="saveOrder">
        <div class="card card-body section-card mb-2" v-for="section in sections" :key="section.id">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <i class="bi-list drag-handle"></i>
              <span class="section-name">{{ sectionName(section) }}</span>
              <span class="badge badge-secondary ml-2">{{ section.logos.length }} log</span>
              <span class="badge badge-light ml-2">{{
                section.displayMode === "INDIVIDUAL" ? "individuální" : "skupina"
              }}</span>
              <span v-if="!section.visible" class="badge badge-warning ml-2">skryté</span>
            </div>
            <div class="col-lg-4 pt-lg-1 text-right">
              <i class="btn btn-danger bi-trash-fill admin-action" @click="deleting = section" />
              <i class="btn btn-primary bi-pencil-square admin-action" @click="editSection(section.id)" />
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <error-modal :message="error" />
    <confirmation-modal :confirm="removeSection" :cancel="() => (deleting = null)" :entity="deleting" />
  </div>
</template>

<script>
import AdminMenu from "@/components/admin/AdminMenu";
import axios from "@/api/axiom-instance";
import ErrorModal from "@/components/admin/ErrorModal";
import ConfirmationModal from "@/components/admin/ConfirmationModal";
import SendButton from "@/components/admin/SendButton";
import draggable from "vuedraggable";
import { VueEditor } from "vue2-editor";

export default {
  name: "SponsorsAdmin",
  components: {
    "app-menu": AdminMenu,
    "error-modal": ErrorModal,
    "confirmation-modal": ConfirmationModal,
    "send-button": SendButton,
    draggable: draggable,
    "html-editor": VueEditor,
  },
  data() {
    return {
      page: { id: null, intro: { cs: "", en: "" }, subtitle: { cs: "", en: "" } },
      sections: [],
      deleting: null,
      error: null,
      dataLoaded: false,
      toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    };
  },
  created() {
    this.loadPage();
    this.loadSections();
  },
  methods: {
    loadPage: function () {
      axios
        .get("/sponsors/page")
        .then((success) => {
          if (success.data) {
            this.page = {
              id: success.data.id,
              intro: success.data.intro || { cs: "", en: "" },
              subtitle: success.data.subtitle || { cs: "", en: "" },
            };
          }
          this.dataLoaded = true;
        })
        .catch((error) => {
          this.dataLoaded = true;
          this.error = error;
        });
    },
    loadSections: function () {
      axios
        .get("/sponsors/section/list")
        .then((success) => {
          this.sections = success.data;
        })
        .catch((error) => (this.error = error));
    },
    savePage: function () {
      axios
        .post("/sponsors/page", this.page)
        .then((success) => {
          this.page.id = success.data.id;
          this.$refs.pageBtn.enable();
        })
        .catch((error) => {
          this.error = error;
          this.$refs.pageBtn.enable();
        });
    },
    sectionName: function (section) {
      if (!section.title) return "(bez nadpisu)";
      const name = this.$options.filters.translation(section.title);
      return name ? name : "(bez nadpisu)";
    },
    addSection: function () {
      this.$router.push({ path: "/admin/sponsors/section/edit" });
    },
    editSection: function (id) {
      this.$router.push({ path: "/admin/sponsors/section/edit/" + id });
    },
    removeSection: function (id) {
      this.deleting = null;
      axios
        .post("/sponsors/section/delete", null, { params: { id: id } })
        .then(() => this.loadSections())
        .catch((error) => (this.error = error));
    },
    saveOrder: function () {
      const ids = this.sections.map((s) => s.id);
      axios
        .post("/sponsors/section/order", ids)
        .then(() => this.loadSections())
        .catch((error) => (this.error = error));
    },
  },
};
</script>

<style scoped>
#sponsorsAdmin {
  min-height: 100vh;
  padding-bottom: 4em;
  overflow: hidden;
}

.section-name {
  font-size: 14pt;
  margin-left: 8px;
}

.drag-handle {
  cursor: move;
  font-size: 1.4rem;
  vertical-align: middle;
}

.admin-action {
  margin: 0 4px;
}
</style>
